export function hasMoreOccurencesThan(
    string: string,
    word: string,
    count: number
) {
    const occurrences = string.split(word).length - 1;
    return occurrences >= count;
}
